import { useEffect } from "react";

function carriesFiles(e: DragEvent): boolean {
  if (e.target instanceof HTMLInputElement && e.target.type === "file") return false;
  return Array.from(e.dataTransfer?.types ?? []).includes("Files");
}

export function usePreventFileDropNavigation() {
  useEffect(() => {
    function onDragOver(e: DragEvent) {
      if (e.defaultPrevented || !carriesFiles(e)) return;
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
    }
    function onDrop(e: DragEvent) {
      if (carriesFiles(e)) e.preventDefault();
    }
    window.addEventListener("dragover", onDragOver);
    window.addEventListener("drop", onDrop);
    return () => {
      window.removeEventListener("dragover", onDragOver);
      window.removeEventListener("drop", onDrop);
    };
  }, []);
}
